import * as React from "react";
import HeroHeading from "./HeroHeading";
import HeroDescription from "./HeroDescription";
import GetInTouchButton from "./GetInTouchButton";

function PeekUnderHood() {
  return (
    <section className="flex flex-col justify-center items-center px-5 py-20 w-full bg-teal-500 min-h-[screen]">
      <div className="flex flex-col justify-center items-center w-full text-center max-w-[1151px]">
        <HeroHeading />
        <HeroDescription />
        <div className="inline-flex">
          <GetInTouchButton />
        </div>
      </div>
    </section>
  );
}

export default PeekUnderHood;
